<ion-content>
  <div class="booking-blocked-content">
    <button class="close-modal" (click)="dismiss()">
      <img src="assets/2022/icons/close-off.svg" alt="Fermer" height="24" />
    </button>
    <img src="assets/2022/icons/lock-on.svg" alt="Verrouill&#xE9;" class="booking-blocked-icon" />
    <h2 class="booking-blocked-title">Tu as le code d&#x2019;entr&#xE9;e ?</h2>
    <p class="booking-blocked-text">
      Pour des raisons p&#xE9;dagogiques, il n&#x2019;est plus possible de commencer tes le&#xE7;ons de conduite avant d&#x2019;avoir ton code. Pourquoi ? Cela
      ralentit ta progression et risque d&#x2019;allonger ta formation... On pr&#xE9;f&#xE8;re t&#x2019;&#xE9;viter &#xE7;a &#x1F3CE;&#xFE0F;
    </p>
    <div class="booking-blocked-actions">
      <button class="btn full-width" (click)="goToDocuments()">J&#x2019;importe mon code</button>
      <button class="btn light full-width" (click)="goToCode()">Je continue mes r&#xE9;visions</button>
    </div>
  </div>
</ion-content>
